import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { FDBodyText } from '@facet-wealth/design';
import { Products } from 'Views/Page/Content/Templates/WizardTemplates/EstatePlanningRecommendation/Components';
import { Layout } from './Layout';
import { EstatePlanningManagementPageFAQ } from '../EstatePlanningManagementPageTemplate/EstatePlanningManagementPageFAQ';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('products', {
    _component: () => Products,
    _customProps: {
      variant: 'tax',
    },
  }, overrideReadOnly)
  .nameOverride('frequentlyAskedQuestions', {
    _component: () => EstatePlanningManagementPageFAQ,
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .done();

const TaxHomePage = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

TaxHomePage.defaultProps = {
};

TaxHomePage.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { TaxHomePage };
